import React from "react";

const formatPrice = (value) => `${Number(value || 0).toFixed(2)} EUR`;

const MarketplaceCartSection = ({
  prodotti,
  totaleStimato,
  noteUtente,
  onNoteChange,
  onProductChange,
  removeProductRow,
  checkoutMode,
  onCheckoutModeChange,
  isAuthenticated,
  onLogin,
  onRegister,
  registrationData,
  onRegistrationFieldChange,
  canShowSubmit,
  isRegistering,
  registrationError,
  registrationSuccess,
  isSubmitting,
  submitError,
  submitSuccess,
  onLogout,
  onSubmitRichiesta,
}) => {
  const showCheckout = prodotti.length > 0;

  return (
    <div className="card dashboard-marketplace-panel">
      <div className="header">
        <h2 className="text-primary">Carrello e invio richiesta</h2>
        <span className="dashboard-marketplace-panel__subtle">
          Aggiungi i prodotti, completa i tuoi dati e invia la richiesta alla rete marketplace
        </span>
      </div>
      <div className="body">
        {prodotti.length === 0 ? (
          <div className="dashboard-marketplace-empty-state">
            <i className="icon-basket"></i>
            <h5>Nessun prodotto nel carrello</h5>
            <p>Aggiungi uno o piu farmaci dalla ricerca per proseguire con la richiesta.</p>
          </div>
        ) : (
          <>
            <div className="dashboard-marketplace-selected-summary">
              <div>
                <strong>{prodotti.length}</strong>
                <span>Prodotti nel carrello</span>
              </div>
              <div>
                <strong>{formatPrice(totaleStimato)}</strong>
                <span>Totale di listino</span>
              </div>
              <div className="dashboard-marketplace-selected-summary__notice">
                <i className="fa fa-balance-scale"></i>
                <div>
                  <strong>Totale indicativo</strong>
                  <span>Il prezzo reale dipenderà dalle offerte che riceverai dai venditori.</span>
                </div>
              </div>
            </div>

            <div className="dashboard-marketplace-selected-products">
              {prodotti.map((prodotto, index) => (
                <div className="dashboard-marketplace-selected-product-card" key={prodotto.id || index}>
                  <div className="dashboard-marketplace-selected-product-card__top">
                    <div>
                      <span className="badge badge-info-light">Nel carrello</span>
                      <h5>{prodotto.nome}</h5>
                      <p className="dashboard-marketplace-selected-product-card__price">
                        Prezzo di listino: {formatPrice(prodotto.prezzoIndicativo)} / conf.
                      </p>
                    </div>
                    <button
                      type="button"
                      className="dashboard-marketplace-remove-cta"
                      onClick={() => removeProductRow(index)}
                      aria-label="Rimuovi prodotto dal carrello"
                      title="Rimuovi prodotto"
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                  <div className="row clearfix">
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group m-b-0">
                        <label>Quantita</label>
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          value={prodotto.quantita}
                          onChange={(event) => onProductChange(index, "quantita", Number(event.target.value || 1))}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group m-b-0">
                        <label>Equivalente</label>
                        <select
                          className="form-control"
                          value={prodotto.equivalenteConsentito ? "SI" : "NO"}
                          onChange={(event) => onProductChange(index, "equivalenteConsentito", event.target.value === "SI")}
                        >
                          <option value="SI">Si</option>
                          <option value="NO">No</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className="dashboard-marketplace-selected-product-card__status">
                        <i className="fa fa-check-circle text-success m-r-5"></i>
                        Totale riga: {formatPrice((Number(prodotto.prezzoIndicativo) || 0) * (Number(prodotto.quantita) || 0))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="dashboard-marketplace-note-review">
              <div className="dashboard-marketplace-note-review__header">
                <span className="badge badge-info-light">Note richiesta</span>
                <h5>Aggiungi indicazioni utili</h5>
                <p>Inserisci preferenze, urgenze o dettagli aggiuntivi prima dell'invio.</p>
              </div>
              <textarea
                className="form-control no-resize dashboard-marketplace-textarea dashboard-marketplace-note-review__textarea"
                rows="4"
                placeholder="Scrivi qui eventuali note aggiuntive"
                value={noteUtente}
                onChange={onNoteChange}
              ></textarea>
            </div>

            {showCheckout ? (
              <div className="dashboard-marketplace-checkout-card">
                <div className="dashboard-marketplace-checkout-card__header">
                  <span className="badge badge-info-light">Checkout</span>
                  <h5>Prima dell'invio scegli come continuare</h5>
                  <p>Accedi o registrati con il tuo account Marketplace per inviare la richiesta e seguirne gli aggiornamenti.</p>
                </div>

                {isAuthenticated ? (
                  <div className="dashboard-marketplace-account-banner dashboard-marketplace-account-banner--actions">
                    <div className="dashboard-marketplace-account-banner__content">
                      <i className="fa fa-user-circle"></i>
                      <div>
                        <strong>Accesso effettuato</strong>
                        <span>Puoi inviare subito la richiesta dal tuo account.</span>
                      </div>
                    </div>
                    <button type="button" className="btn dashboard-marketplace-logout-cta" onClick={onLogout}>
                      <i className="icon-logout m-r-8"></i>
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="dashboard-marketplace-checkout__switch">
                      <button
                        type="button"
                        className={`dashboard-marketplace-checkout__option ${checkoutMode === "register" ? "is-active" : ""}`}
                        onClick={() => onCheckoutModeChange("register")}
                      >
                        Registrati
                      </button>
                      <button
                        type="button"
                        className={`dashboard-marketplace-checkout__option ${checkoutMode === "login" ? "is-active" : ""}`}
                        onClick={onLogin}
                      >
                        Accedi
                      </button>
                    </div>

                    {checkoutMode === "register" ? (
                      <div className="dashboard-marketplace-registration-form">
                        <div className="row clearfix">
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label>Nome</label>
                              <input
                                type="text"
                                className="form-control"
                                value={registrationData.firstName}
                                onChange={(event) => onRegistrationFieldChange("firstName", event.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label>Cognome</label>
                              <input
                                type="text"
                                className="form-control"
                                value={registrationData.lastName}
                                onChange={(event) => onRegistrationFieldChange("lastName", event.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label>Email</label>
                              <input
                                type="email"
                                className="form-control"
                                value={registrationData.email}
                                onChange={(event) => onRegistrationFieldChange("email", event.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label>Codice fiscale</label>
                              <input
                                type="text"
                                className="form-control"
                                value={registrationData.codiceFiscale || ""}
                                onChange={(event) => onRegistrationFieldChange("codiceFiscale", event.target.value.toUpperCase())}
                              />
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-12">
                            <div className="form-group">
                              <label>Indirizzo</label>
                              <input
                                type="text"
                                className="form-control"
                                value={registrationData.address}
                                onChange={(event) => onRegistrationFieldChange("address", event.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-12">
                            <div className="form-group m-b-0">
                              <label>Password</label>
                              <input
                                type="password"
                                className="form-control"
                                value={registrationData.password}
                                onChange={(event) => onRegistrationFieldChange("password", event.target.value)}
                              />
                            </div>
                          </div>
                        </div>

                        {registrationError ? <div className="alert alert-danger m-t-15 m-b-0">{registrationError}</div> : null}
                        {registrationSuccess ? <div className="alert alert-success m-t-15 m-b-0">{registrationSuccess}</div> : null}

                        <button
                          type="button"
                          className="btn marketplace-header-vendor-btn dashboard-marketplace-auth-cta dashboard-marketplace-register-cta"
                          onClick={onRegister}
                          disabled={isRegistering}
                        >
                          <i className={`fa ${isRegistering ? "fa-circle-o-notch fa-spin" : "fa-user-plus"} m-r-10`}></i>
                          {isRegistering ? "Registrazione in corso..." : "Crea account Marketplace"}
                        </button>
                      </div>
                    ) : (
                      <div className="dashboard-marketplace-login-panel">
                        <p>Accedi con Keycloak per recuperare i tuoi dati e completare l'invio dal tuo profilo Marketplace.</p>
                        <button
                          type="button"
                          className="btn marketplace-header-vendor-btn dashboard-marketplace-auth-cta dashboard-marketplace-login-cta"
                          onClick={onLogin}
                        >
                          <i className="fa fa-sign-in m-r-10"></i>
                          Accedi
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            ) : null}

            {isSubmitting ? (
              <div className="dashboard-marketplace-submit-feedback is-loading">
                <i className="fa fa-circle-o-notch fa-spin"></i>
                <div>
                  <strong>Invio richiesta in corso</strong>
                  <span>Stiamo contattando i venditori compatibili. Attendi qualche secondo.</span>
                </div>
              </div>
            ) : null}

            {!isSubmitting && submitSuccess ? (
              <div className="dashboard-marketplace-submit-feedback is-success">
                <i className="fa fa-check-circle"></i>
                <div>
                  <strong>Richiesta inviata correttamente</strong>
                  <span>{submitSuccess}</span>
                </div>
              </div>
            ) : null}

            {!isSubmitting && submitError ? (
              <div className="dashboard-marketplace-submit-feedback is-error">
                <i className="fa fa-exclamation-circle"></i>
                <div>
                  <strong>Invio non completato</strong>
                  <span>{submitError}</span>
                </div>
              </div>
            ) : null}

            {canShowSubmit ? (
              <div className="dashboard-marketplace-selected-actions">
                <div className="dashboard-marketplace-selected-actions__meta">
                  <span>Totale di listino</span>
                  <strong>{formatPrice(totaleStimato)}</strong>
                </div>
                <button
                  type="button"
                  className="btn btn-primary dashboard-marketplace-submit-main"
                  onClick={onSubmitRichiesta}
                  disabled={isSubmitting}
                >
                  <i className="fa fa-paper-plane m-r-10"></i>
                  {isSubmitting ? "Invio in corso..." : "Invia richiesta"}
                </button>
              </div>
            ) : (
              <div className="dashboard-marketplace-submit-gate">
                <i className="fa fa-lock"></i>
                <div>
                  <strong>Completa l'accesso per inviare</strong>
                  <span>
                    Il pulsante di invio compare dopo aver aggiunto i farmaci e completato accesso o registrazione su Marketplace.
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MarketplaceCartSection;

